import { Styles } from './Combo.styles';
import { ComboCard, ComboChoices } from './components';
import ComboProducts from './components/ComboProducts';
import type { ComboProps } from './Combo.d';

export const Combo = ({
  addCombo,
  choices,
  comboData,
  handleCombo,
  handleComboItem,
  isMobile,
  products,
}: ComboProps) => {
  const { available, canAddCombo, image, name, price, quantity, sku } = comboData;

  return (
    <Styles.Wrapper>
      <ComboCard
        available={available}
        image={image}
        isDisabled={!canAddCombo}
        isMobile={isMobile}
        name={name}
        onAddCombo={addCombo}
        onChange={handleCombo}
        price={price}
        quantity={quantity}
        sku={sku}
      />
      <Styles.Options>
        <ComboChoices
          choices={choices}
          comboQuantity={quantity}
          isMobile={isMobile}
          onChangeItem={handleComboItem}
        />
        <ComboProducts products={products} />
      </Styles.Options>
    </Styles.Wrapper>
  );
};
